var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "printing-template directions-template" }, [
    _c("h2", { domProps: { innerHTML: _vm._s(_vm.place.placeName) } }),
    _vm._v(" "),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c("img", {
      attrs: {
        alt: "Map print view",
        width: "auto",
        height: "400",
        src: _vm.mapViewImage
      }
    }),
    _vm._v(" "),
    _c("div", [
      _vm.place.placeName
        ? _c("div", [
            _vm._v(_vm._s(_vm.$t("placeDetails.placeName")) + ": "),
            _c("b", [_vm._v(_vm._s(_vm.place.placeName))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.place.properties.country
        ? _c("div", [
            _vm._v(_vm._s(_vm.$t("global.layers.country")) + ": "),
            _c("b", [_vm._v(_vm._s(_vm.place.properties.country))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm._v(_vm._s(_vm.$t("placeDetails.layer")) + ": "),
        _c("b", [
          _vm._v(_vm._s(_vm.$t("global.layers." + _vm.place.properties.layer)))
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(_vm._s(_vm.$t("placeDetails.lon")) + ": "),
        _c("b", [_vm._v(_vm._s(_vm.place.lng))])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(_vm._s(_vm.$t("placeDetails.lat")) + ": "),
        _c("b", [_vm._v(_vm._s(_vm.place.lat))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-473a8856", { render: render, staticRenderFns: staticRenderFns })
  }
}